// a method wrapper for classes created with 'inherit' or for non-method functions
// TODO: extend/convert to a regular decorator
// TODO: move all decorator-related logic to some helper
function cacheMethodResult({ target }) {
    // TODO: consider extracting scope-related logic to a general helper like createStatefulFunctionWrapper

    // as the wrapper is stateful, we need to track all additional data separately for each object instance it's called on
    const hostInstanceScopes = new WeakMap();

    // a single scope for 'free' functions that are called not as object methods
    let globalScope = null;

    function targetWithCaching(...args) {
        const now = Date.now();

        const instanceScope = _getScope(this, {
            cachedResult: null,
            cacheExpirationTime: null,
        });
        const shouldRecalculateCache =
            !instanceScope.cacheExpirationTime ||
            instanceScope.cacheExpirationTime < now;

        if (shouldRecalculateCache) {
            // pass original 'this'
            instanceScope.cachedResult = target.apply(this, args);
            instanceScope.cacheExpirationTime = now + APP_LEVEL_CACHE_LIFETIME;
        }

        return instanceScope.cachedResult;
    }

    targetWithCaching._invalidateCache = function() {
        _getScope(this).cacheExpirationTime = null;
    };

    return targetWithCaching;

    function _getScope(instance, initialValue) {
        const isObjectMethod = !!instance;

        if (isObjectMethod) {
            if (!hostInstanceScopes.has(instance)) {
                hostInstanceScopes.set(instance, initialValue);
            }

            return hostInstanceScopes.get(instance);
        }
        if (!globalScope) {
            globalScope = initialValue;
        }

        return globalScope;
    }
}

export { cacheMethodResult };

const APP_LEVEL_CACHE_LIFETIME = 10000;
